import { render, staticRenderFns } from "./zTomIndex_kdr.vue?vue&type=template&id=fb04540a&scoped=true&"
import script from "./zTomIndex_kdr.vue?vue&type=script&lang=js&"
export * from "./zTomIndex_kdr.vue?vue&type=script&lang=js&"
import style0 from "./zTomIndex_kdr.vue?vue&type=style&index=0&id=fb04540a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb04540a",
  null
  
)

export default component.exports